import React from 'react';
import { arrayOf, string } from 'prop-types';
import {
  params,
  shape,
  string as stringType,
  extend,
  QueryProvider,
  useDataModel,
  arrayOf as arrayType,
} from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { Row } from '@thd-olt-component-react/core-ui';
import styles from './tools-materials.module.scss';

export const SecondCall = ({ itemIds, storeId }) => {
  const {
    data,
    loading,
  } = useDataModel('searchModel', {
    variables: { itemIds, storeId },
  });

  if (loading) {
    return <div className={styles.placeholder1} />;
  }

  const productData = data?.searchModel?.products || [];

  return productData.map((products, index) => {
    return (
      <div
        style={{ paddingTop: '10px', borderBottom: '3px solid #F5F5F5' }}
        key={`related-products-${index}`}
      >
        <Row key={`related-products-${index}`}>
          <QueryProvider
            cacheKey="search-product-pods"
            defaultVariables={{ storeId: '121' }}
            dataSource="searchNav"
          >
            <ProductPod
              miniOptions={{
                onAction: () => {},
                enableATC: true,
                hideCaret: true
              }}
              isCTALocationPropBottom={false}
              dataSource="searchNav"
              storeId={storeId}
              itemId={products?.itemId}
              podType="mini"
              showKPF={false}
              isHDQCSku
              onHeaderClick={(event) => {
                event.preventDefault();
              }}
            />
          </QueryProvider>
        </Row>
      </div>
    );
  });
};

SecondCall.propTypes = {
  itemIds: arrayOf(string).isRequired,
  storeId: string.isRequired
};

const product = extend({}, ProductPod.dataModel.product);
SecondCall.dataModel = {
  searchModel: params({
    itemIds: arrayType(stringType()).isRequired(),
    storeId: stringType(),
  }).shape({
    products: arrayType(shape(product)),
  }),
};
